import React from 'react';
import { StarIcon } from 'lucide-react';
type Testimonial = {
  quote: string;
  author: string;
  role?: string;
  avatar?: string;
};
type TestimonialsProps = {
  testimonials: Testimonial[];
  title?: string;
  subtitle?: string;
  background?: 'white' | 'blush';
};
export function Testimonials({
  testimonials,
  title = 'What teachers are saying',
  subtitle,
  background = 'white'
}: TestimonialsProps) {
  const bg = background === 'white' ? 'bg-white' : 'bg-blush';
  return <section aria-label={title} className={`w-full text-ink ${bg}`} data-id="element-281" data-mp="32060asnov9lo">
      <div className="max-w-6xl mx-auto px-5 py-16 sm:py-20" data-id="element-282" data-mp="321z8icdya1vs">
        <div className="text-center" data-id="element-283" data-mp="2x1uq2gthex2x">
          <p className="text-[11px] font-semibold uppercase tracking-[1.8px] text-coral-deep" data-id="element-284" data-mp="2x2w50wdmc3px">
            Teacher to teacher
          </p>
          <h2 className="mt-3 font-display font-bold text-plum text-3xl sm:text-5xl" data-id="element-285" data-mp="v9yfpaj1vt9q">
            {title}
          </h2>
          {subtitle && <p className="mx-auto mt-4 max-w-2xl text-sm text-ink-soft" data-id="element-286" data-mp="qb4zhacdpo5v">
              {subtitle}
            </p>}
        </div>

        <div className="mt-9 grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-287" data-mp="m4roidrgpg6y">
          {testimonials.map((item, i) => <figure key={i} className="rounded-3xl border border-cream-dark bg-white p-5 shadow-card" data-id="element-288" data-mp="78k4bdg20ero" data-mpi={i}>
              <div className="flex items-center gap-2.5" data-id="element-289" data-mp="c8y09x4dry9c">
                {item.avatar ? <img src={item.avatar} alt={item.author} width={44} height={44} loading="lazy" className="h-11 w-11 rounded-full object-cover ring-2 ring-cream-dark" data-id="element-290" data-mp="zx7rjekd5e7v" /> : <span className="flex h-11 w-11 items-center justify-center rounded-full bg-plum font-display text-[13px] font-bold text-gold" data-id="element-291" data-mp="1ivadtllj0x1z">
                    {item.author.replace(/[^A-Za-z ]/g, '').split(' ').map(w => w[0]).join('').slice(0, 2).toUpperCase() || 'DC'}
                  </span>}
                <span className="flex gap-0.5" aria-label="Five out of five" data-id="element-292" data-mp="1ofrf4r1lyeof">
                  {[0, 1, 2, 3, 4].map(s => <StarIcon key={s} className="h-3.5 w-3.5 fill-gold text-gold" aria-hidden="true" data-id="element-293" data-mp="1jkke5qzq3o37" />)}
                </span>
              </div>
              <blockquote className="mt-3 text-[15px] leading-relaxed text-ink" data-id="element-294" data-mp="14ud6m6b97pha">
                “{item.quote}”
              </blockquote>
              <figcaption className="mt-4 text-xs text-ink-soft" data-id="element-295" data-mp="10pnduqbw6r0l">
                <span className="block font-display text-[13px] font-bold text-plum" data-id="element-296" data-mp="vrc38ddrwchb">
                  {item.author}
                </span>
                {item.role}
              </figcaption>
            </figure>)}
        </div>
      </div>
    </section>;
}